module.exports = __webpack_public_path__ + "static/media/Item_Weapon_MG3_C.b8e69794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_MG3_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_MG3_C.png
// module chunks = 0